/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JQLBuilderWithAIEntrypointProps } from './JQLBuilderWithAI.entrypoint.types.tsx';

type JQLBuilderWithAIEntryPointComponent = EntryPointComponent<
	{},
	{},
	JQLBuilderWithAIEntrypointProps,
	{}
>;

export const jqlBuilderWithAiEntryPoint: EntryPoint<JQLBuilderWithAIEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<JQLBuilderWithAIEntryPointComponent>(
			/* webpackChunkName: "async-jql-builder-with-ai" */ './JQLBuilderWithAIEntryPoint.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => ({}),
	});
